/* eslint-disable no-unused-vars */
import styled, { css } from 'styled-components';
import { Palette } from 'config';

export const Container = styled.div`
  border: 1px solid ${Palette.PrimaryGray._200};
  /* width: 1536px; */
  width: 100%;
  border-bottom: none;
  background: #fff;
  padding: 8px 16px;
  display: flex;
  align-items: center;
`;
